import request from '@/utils/request'

/**
 * 获取ossToken
 * @returns
 */
export function getOssToken () {
  return request({
    url: '/zstp/neo4j/rsfd/',
    method: 'post',
    data: {
      url: '/v1/oss/token',
      params: {
        oss_prefix: 'zstp',
        authenticate: true
      }
    }
  })
}

export function feedbackMeta () {
  return request({
    url: '/zstp/neo4j/rsfd/',
    method: 'post',
    data: {
      url: '/v1/feedback/meta',
      params: {
        feedback_type: 'knowledge_graph'
      }
    }
  })
}

export function submit (data) {
  return request({
    url: '/zstp/neo4j/rsfd_post/',
    method: 'post',
    data: {
      url: '/v1/feedback/add?authenticate=true',
      params: data
    }
  })
}
